import WarningIcon from '../icons/WarningIcon';
import PopupCommonExternal, { PopupCommonExternalProps } from './PopupCommonExternal';

export default function PopupWarning({ ...props }: PopupCommonExternalProps) {
	return <PopupCommonExternal {...props} icon={<WarningIcon color='error' className='text-6xl' />} />;
}
